import * as API from "middleware/api";

export const listCreditLinesRequest = () => API.executeWithAccessToken("/list.creditLines");

export const productCreditLinesListRequest = (creditLineNumber) =>
    API.executeWithAccessToken("/list.creditLines.details", { creditLineNumber });
